module.exports = __webpack_public_path__ + "img/animals_rabbit_1.1886cf36.svg";